import { NfzDepartment } from '@dreryk/egabinet-nfz-configuration-frontend-api';

import { SelectFilterCreator, SelectTriggerLabelExtractor } from '@dreryk/react-components';

export const nfzDepartmentTriggerLabelExtractor: SelectTriggerLabelExtractor<NfzDepartment> = (department) =>
   `${department.name} (${department.code})`;

export const nfzDepartmentSelectFilterCreator: SelectFilterCreator<NfzDepartment> = ({ includes }) => (department) =>
   includes(department.name);
